"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSanitizedTapeSuccess = exports.isSanitizedTapeFailure = exports.isRequiredBaseFieldConfig = exports.getSanitizedDataTapeField = exports.getSanitizedFieldName = exports.getSanitizedRowData = exports.consolidateToStructuredErrors = exports.toColumnInfo = exports.transformDataTapeDefinition = exports.transformDataTapeForTest = exports.transformDataTape = exports.sanitizeTape = exports.validateTapeFilename = exports.stream = exports.getXlsxHeaderValues = exports.readWorkbook = exports.parsePyExtractionParams = exports.extractVirtualSheetConfiguration = exports.FINANCIAL_STATEMENT_BASE_FIELDS = exports.mapBaseFieldsTemplateToFinleySubType = exports.baseFieldsToFinleyArrayJsonSchema = exports.generateTypeDefinition = exports.generateTapeFieldStats = exports.generateXlsx2CsvExtractConfigFromXLSX = exports.generateTapeDefinitionFromCSV = exports.ExtractionStruct = exports.createSanitizedFieldConfigs = exports.preFilter = exports.AssetExtractor = void 0;
const _ = __importStar(require("lodash"));
const luxon_1 = require("luxon");
const common_1 = require("@finley-technologies/common");
const ai2csv_transform_1 = require("./ai2csv-transform");
const asset2json_1 = require("./asset2json");
const attachHeader_transform_1 = require("./attachHeader-transform");
const edit_transform_1 = require("./edit-transform");
const filter_transform_1 = require("./filter-transform");
const flatten_transform_1 = require("./flatten-transform");
const helpers_1 = require("./helpers");
Object.defineProperty(exports, "getSanitizedRowData", { enumerable: true, get: function () { return helpers_1.getSanitizedRowData; } });
Object.defineProperty(exports, "getSanitizedDataTapeField", { enumerable: true, get: function () { return helpers_1.getSanitizedDataTapeField; } });
Object.defineProperty(exports, "getSanitizedFieldName", { enumerable: true, get: function () { return helpers_1.getSanitizedFieldName; } });
Object.defineProperty(exports, "createSanitizedFieldConfigs", { enumerable: true, get: function () { return helpers_1.createSanitizedFieldConfigs; } });
const join_transform_1 = require("./join-transform");
const pdf2csv_1 = require("./pdf2csv");
const preFilter_transform_1 = require("./preFilter-transform");
const pyCsvVirtualSheet_transform_1 = require("./pyCsvVirtualSheet-transform");
const pyXlsx2Csv2_transform_1 = require("./pyXlsx2Csv2-transform");
const pyXlsxVirtualSheet2Csv_transform_1 = require("./pyXlsxVirtualSheet2Csv-transform");
const sanitize_transform_1 = require("./sanitize-transform");
Object.defineProperty(exports, "consolidateToStructuredErrors", { enumerable: true, get: function () { return sanitize_transform_1.consolidateToStructuredErrors; } });
const stack_transform_1 = require("./stack-transform");
const transformation_1 = require("./transformation");
Object.defineProperty(exports, "ExtractionStruct", { enumerable: true, get: function () { return transformation_1.ExtractionStruct; } });
const typeguards_1 = require("./typeguards");
Object.defineProperty(exports, "isRequiredBaseFieldConfig", { enumerable: true, get: function () { return typeguards_1.isRequiredBaseFieldConfig; } });
Object.defineProperty(exports, "isSanitizedTapeFailure", { enumerable: true, get: function () { return typeguards_1.isSanitizedTapeFailure; } });
Object.defineProperty(exports, "isSanitizedTapeSuccess", { enumerable: true, get: function () { return typeguards_1.isSanitizedTapeSuccess; } });
const unzip_transform_1 = require("./unzip-transform");
const xlsx2csv_1 = require("./xlsx2csv");
const xlsx2csv2_1 = require("./xlsx2csv2");
__exportStar(require("./transformation"), exports);
exports.AssetExtractor = __importStar(require("./assetExtractor"));
exports.preFilter = __importStar(require("./preFilter-transform"));
var generateTapeDefinition_1 = require("./generateTapeDefinition");
Object.defineProperty(exports, "generateTapeDefinitionFromCSV", { enumerable: true, get: function () { return generateTapeDefinition_1.generateTapeDefinitionFromCSV; } });
Object.defineProperty(exports, "generateXlsx2CsvExtractConfigFromXLSX", { enumerable: true, get: function () { return generateTapeDefinition_1.generateXlsx2CsvExtractConfigFromXLSX; } });
Object.defineProperty(exports, "generateTapeFieldStats", { enumerable: true, get: function () { return generateTapeDefinition_1.generateTapeFieldStats; } });
Object.defineProperty(exports, "generateTypeDefinition", { enumerable: true, get: function () { return generateTapeDefinition_1.generateTypeDefinition; } });
var ai2csv_transform_2 = require("./ai2csv-transform");
Object.defineProperty(exports, "baseFieldsToFinleyArrayJsonSchema", { enumerable: true, get: function () { return ai2csv_transform_2.baseFieldsToFinleyArrayJsonSchema; } });
Object.defineProperty(exports, "mapBaseFieldsTemplateToFinleySubType", { enumerable: true, get: function () { return ai2csv_transform_2.mapBaseFieldsTemplateToFinleySubType; } });
Object.defineProperty(exports, "FINANCIAL_STATEMENT_BASE_FIELDS", { enumerable: true, get: function () { return ai2csv_transform_2.FINANCIAL_STATEMENT_BASE_FIELDS; } });
var virtualSheetConfiguration_1 = require("./virtualSheetConfiguration");
Object.defineProperty(exports, "extractVirtualSheetConfiguration", { enumerable: true, get: function () { return virtualSheetConfiguration_1.extractVirtualSheetConfiguration; } });
var pyXlsx2Csv2_transform_2 = require("./pyXlsx2Csv2-transform");
Object.defineProperty(exports, "parsePyExtractionParams", { enumerable: true, get: function () { return pyXlsx2Csv2_transform_2.parsePyExtractionParams; } });
var readWorkbook_1 = require("./readWorkbook");
Object.defineProperty(exports, "readWorkbook", { enumerable: true, get: function () { return readWorkbook_1.readWorkbook; } });
var xlsx2csv2_2 = require("./xlsx2csv2");
Object.defineProperty(exports, "getXlsxHeaderValues", { enumerable: true, get: function () { return xlsx2csv2_2.getXlsxHeaderValues; } });
exports.stream = __importStar(require("./stream"));
const validateTapeFilename = (filename, baseFilename) => {
    const regexStr = `^${baseFilename}-(\\d{4}-\\d{2}-\\d{2})(?:-v(\\d+))?$`;
    const regex = new RegExp(regexStr);
    const matches = regex.exec(filename);
    if (matches === null) {
        return { isValid: false };
    }
    return {
        isValid: true,
        reportingDate: matches[1],
        version: parseInt(matches[2], 10) || 1,
    };
};
exports.validateTapeFilename = validateTapeFilename;
const sanitizeTape = async ({ csv, baseFieldConfig, externalReferenceIdField, 
// if assignmentFilter is not specified
// we will use a default filter that returns true for all rows.
assignmentFilter = () => true, delimiter = ',', sanitizeFieldNames = true, csvParser, }) => {
    try {
        const { originalHeaders, csvArray: preAssignCsvArray, } = await common_1.csvConversion.finleyBufferToCsvArray({
            buffer: csv,
            csvParser,
            delimiter,
            headerRenameFunction: (rawHeader) => (0, helpers_1.getSanitizedFieldName)(rawHeader, sanitizeFieldNames),
        });
        const preSanitized = originalHeaders.includes('finley_sanitized');
        // Validate no duplicates prior to handling by Papa parse
        const errors = (0, helpers_1.validateHeaders)({
            headers: originalHeaders,
            externalIdField: externalReferenceIdField,
        });
        if (errors.length) {
            return {
                isValid: false,
                errors,
            };
        }
        const baseFieldConfigs = (0, helpers_1.createSanitizedFieldConfigs)({
            baseFields: baseFieldConfig,
            sanitizeFieldNames,
        });
        const csvArray = preAssignCsvArray.filter(assignmentFilter);
        const result = (0, helpers_1.getSanitizedCsvData)({
            csvArray,
            baseFieldConfigs,
            externalReferenceIdField,
            preSanitized,
        });
        if (result.isValid) {
            return result;
        }
        return {
            isValid: false,
            errors: result.fieldValidationErrors,
        };
    }
    catch (error) {
        return {
            isValid: false,
            errors: [
                {
                    type: 'metadataValidation',
                    message: (0, common_1.getErrorMessage)(error),
                },
            ],
        };
    }
};
exports.sanitizeTape = sanitizeTape;
const transformDataTape = ({ buffersWithExtensions, transformation, csvParser, pdfExtractor, pyXlsx2Csv2Extractor, assetExtractor, pyXlsxVirtualSheet2CsvExtractor, pyCsvVirtualSheetExtractor, ai2CsvExtractor, }) => {
    (0, common_1.finleyAssert)(buffersWithExtensions.length >= 1, 'buffersWithExtensions is required');
    const dataTapeBuffers = buffersWithExtensions.map((bufferWithExtension) => bufferWithExtension.buffer);
    switch (transformation.operation) {
        case 'attachHeader': {
            return attachHeader_transform_1.transformOperation.performTransform({
                dataTapeBuffers,
                transformation,
            });
        }
        case 'xlsx2csv2': {
            return xlsx2csv2_1.transformOperation.performTransform({
                dataTapeBuffers,
                transformation,
            });
        }
        case 'edit':
            return edit_transform_1.transformOperation.performTransform({
                dataTapeBuffers,
                transformation,
                csvParser,
            });
        case 'preFilter':
            return preFilter_transform_1.transformOperation.performTransform({
                dataTapeBuffers,
                transformation,
            });
        case 'filter':
            return filter_transform_1.transformOperation.performTransform({
                dataTapeBuffers,
                transformation,
                csvParser,
            });
        case 'stack': {
            return stack_transform_1.transformOperation.performTransform({
                dataTapeBuffers,
                transformation,
            });
        }
        case 'asset2json':
            (0, common_1.finleyAssert)(assetExtractor, 'assetExtractor is required');
            return asset2json_1.transformOperation.performTransform({
                buffersWithExtensions,
                transformation,
                assetExtractor,
            });
        case 'join':
            return join_transform_1.transformOperation.performTransform({
                dataTapeBuffers,
                transformation,
                csvParser,
            });
        case 'flatten':
            return flatten_transform_1.transformOperation.performTransform({
                dataTapeBuffers,
                transformation,
                csvParser,
            });
        case 'pdf2csv':
            (0, common_1.finleyAssert)(pdfExtractor, 'pdfExtractor is required');
            return pdf2csv_1.transformOperation.performTransform({
                dataTapeBuffers,
                transformation,
                pdfExtractor,
            });
        case 'unzip':
            return unzip_transform_1.transformOperation.performTransform({
                dataTapeBuffers,
                transformation,
            });
        case 'pyXlsx2Csv2':
            (0, common_1.finleyAssert)(pyXlsx2Csv2Extractor, 'pyXlsx2Csv2Extractor is required');
            return pyXlsx2Csv2_transform_1.transformOperation.performTransform({
                buffersWithExtensions,
                transformation,
                pyXlsx2Csv2Extractor,
            });
        case 'pyXlsxVirtualSheet2Csv':
            (0, common_1.finleyAssert)(pyXlsxVirtualSheet2CsvExtractor, 'pyXlsxVirtualSheet2CsvExtractor is required');
            return pyXlsxVirtualSheet2Csv_transform_1.transformOperation.performTransform({
                buffersWithExtensions,
                transformation,
                csvParser,
                pyXlsxVirtualSheet2CsvExtractor,
            });
        case 'xlsx2csv': {
            return xlsx2csv_1.transformOperation.performTransform({
                dataTapeBuffers,
                transformation,
            });
        }
        case 'sanitize':
            return sanitize_transform_1.transformOperation.performTransform({
                dataTapeBuffers,
                transformation,
                csvParser,
            });
        case 'pyCsvVirtualSheet':
            (0, common_1.finleyAssert)(pyCsvVirtualSheetExtractor, 'pyCsvVirtualSheetExtractor is required');
            return pyCsvVirtualSheet_transform_1.transformOperation.performTransform({
                transformation,
                pyCsvVirtualSheetExtractor,
                csvParser,
            });
        case 'ai2Csv':
            (0, common_1.finleyAssert)(ai2CsvExtractor, 'ai2CsvExtractor is required');
            return ai2csv_transform_1.transformOperation.performTransform({
                transformation,
                ai2CsvExtractor,
                csvParser,
            });
        default:
            return (0, common_1.finleyAssertUnreachable)(transformation);
    }
};
exports.transformDataTape = transformDataTape;
const transformDataTapeForTest = (params) => {
    return (0, exports.transformDataTape)({
        csvParser: common_1.csvConversion.smallCsvParser,
        ...params,
    });
};
exports.transformDataTapeForTest = transformDataTapeForTest;
const transformDataTapeDefinition = (transformation) => {
    switch (transformation.operation) {
        case 'attachHeader':
            return attachHeader_transform_1.transformOperation.validateTransform(transformation);
        case 'xlsx2csv2':
            return xlsx2csv2_1.transformOperation.validateTransform(transformation);
        case 'edit':
            return edit_transform_1.transformOperation.validateTransform(transformation);
        case 'preFilter':
            return preFilter_transform_1.transformOperation.validateTransform(transformation);
        case 'filter':
            return filter_transform_1.transformOperation.validateTransform(transformation);
        case 'stack':
            return stack_transform_1.transformOperation.validateTransform(transformation);
        case 'asset2json':
            return asset2json_1.transformOperation.validateTransform(transformation);
        case 'join':
            return join_transform_1.transformOperation.validateTransform(transformation);
        case 'flatten':
            return flatten_transform_1.transformOperation.validateTransform(transformation);
        case 'pdf2csv':
            return pdf2csv_1.transformOperation.validateTransform(transformation);
        case 'unzip':
            return unzip_transform_1.transformOperation.validateTransform(transformation);
        case 'pyXlsx2Csv2':
            return pyXlsx2Csv2_transform_1.transformOperation.validateTransform(transformation);
        case 'sanitize':
            return sanitize_transform_1.transformOperation.validateTransform(transformation);
        case 'xlsx2csv':
            return xlsx2csv_1.transformOperation.validateTransform(transformation);
        case 'pyXlsxVirtualSheet2Csv':
            return pyXlsxVirtualSheet2Csv_transform_1.transformOperation.validateTransform(transformation);
        case 'pyCsvVirtualSheet':
            return pyCsvVirtualSheet_transform_1.transformOperation.validateTransform(transformation);
        case 'ai2Csv':
            return ai2csv_transform_1.transformOperation.validateTransform(transformation);
        default:
            return (0, common_1.finleyAssertUnreachable)(transformation);
    }
};
exports.transformDataTapeDefinition = transformDataTapeDefinition;
const toColumnInfo = (baseConfig) => {
    let type;
    let examples;
    switch (baseConfig.type) {
        case 'boolean':
        case 'optionalBoolean':
            type = 'boolean';
            examples = [baseConfig.externalBooleanTrue];
            break;
        case 'currency':
        case 'optionalCurrency':
            type = 'currency';
            switch (baseConfig.currencyCode) {
                case 'USD':
                case 'CAD':
                case 'MXN':
                case 'EUR':
                case 'GBP':
                    examples = ['$100.00', '100', '-100.00', '(100)'];
                    break;
                default:
                    return (0, common_1.finleyAssertUnreachable)(baseConfig.currencyCode);
            }
            break;
        case 'date':
        case 'optionalDate': {
            type = 'date';
            // Select representative dates:
            // - 1999 is unambiguously a year, even when abbreviated
            // - 31 is unambiguously a date
            // - 01 demonstrates zero-padding behavior
            examples = [
                luxon_1.DateTime.fromObject({
                    year: 1999,
                    month: 1,
                    day: 1,
                }).toFormat(baseConfig.externalDateFormat),
                luxon_1.DateTime.fromObject({
                    year: 1999,
                    month: 1,
                    day: 31,
                }).toFormat(baseConfig.externalDateFormat),
            ];
            break;
        }
        case 'dateTime':
        case 'optionalDateTime': {
            type = 'date/time';
            // Select representative dates:
            // - 1999 is unambiguously a year, even when abbreviated
            // - 31 is unambiguously a date
            // - 01 demonstrates zero-padding behavior
            // - Also demonstrate eastern time vs UTC
            examples = [
                luxon_1.DateTime.fromObject({
                    year: 1999,
                    month: 1,
                    day: 1,
                    hour: 10,
                    minute: 45,
                }).toFormat(baseConfig.externalDateTimeFormat),
                luxon_1.DateTime.fromObject({
                    year: 1999,
                    month: 1,
                    day: 31,
                    hour: 10,
                    minute: 45,
                    zone: 'UTC',
                }).toFormat(baseConfig.externalDateTimeFormat),
            ];
            break;
        }
        case 'float':
        case 'optionalFloat':
            type = 'float (decimal numbers)';
            examples = ['100', '100.0', '-100.0'];
            break;
        case 'integer':
        case 'optionalInteger':
            type = 'integer (whole numbers)';
            examples = ['100', '-100'];
            break;
        case 'percentage':
        case 'optionalPercentage':
            type = 'percentage';
            examples = ['10%', '10.00%', '10.0'];
            break;
        case 'string':
        case 'optionalString':
            type = 'text';
            examples = []; // Too open-ended to provide guidance. We'll rely on the description field.
            break;
        default:
            return (0, common_1.finleyAssertUnreachable)(baseConfig);
    }
    return {
        // the column header to look for in the file, as sanitize and xlsx2csv2 read it.
        name: baseConfig.columnToReadFrom ?? baseConfig.field,
        // If a default value is specified, report the field as optional.
        required: (0, typeguards_1.isRequiredBaseFieldConfig)(baseConfig) && _.isNil(baseConfig.defaultTo),
        type,
        description: baseConfig.description ?? '',
        examples,
        defaultValue: (0, typeguards_1.isRequiredBaseFieldConfig)(baseConfig) && !_.isNil(baseConfig.defaultTo)
            ? baseConfig.defaultTo
            : null,
    };
};
exports.toColumnInfo = toColumnInfo;
//# sourceMappingURL=index.js.map